import * as Yup from 'yup';

export const createAddressValidationSchema = (forceUnitPrompt: boolean) =>
  Yup.object({
    inputValue: Yup.string().required('Please enter your address to check availability.'),
    // Validates the address data, not its provenance. Gating on a provider id
    // here is what used to make a complete hand-typed address unsubmittable.
    resolvedAddress: Yup.object()
      .nullable()
      .required('Please select an address from the suggestions to continue.'),
    unitNumber: forceUnitPrompt
      ? Yup.string()
          .transform((value: string) => (typeof value === 'string' ? value.trim() : value))
          .required('An apartment, unit or suite number is required.')
      : Yup.string(),
  });
